import { messages } from "../constants/commonMessages";

export const authRoutes = {
  changePassword: "change-password",
  forgotPassword: "forgot-password",
  oktaLogin: "okta-user/",
};

export const investigatorRoutes = {
  investigationAnalysis: "investigation-analysis",
  logs: "logs",
  // visualizationInterface: "visualization-interface",
  taskStatus: "task-status",
  filesPreview: "files-preview",
  oldLogs: "old-logs",
};

export const manageDataRoute = {
  reviewList: "review-list",
  reviewBatches: "review-batches",
  copyHistory: "review-copy-history",
};

export const configuration = {
  productList: "conf-product-list",
  siteList: "conf-site-list",
  uopList: "conf-uop-list",
  paramterList: "conf-parameter-list",
  auditList: "conf-audit-list",
  configAuditTrail: "config-audit-trail",
  versionHistory: "version-history",
};

export const analyticsRoutes = {
  analytics: `analytics/${messages.ALL_REPORTS}`,
  visualizationInterface: `analytics/${messages.VISUALIZATION}`,
  process: `analytics/${messages.PROCESS}`,
  limit: `analytics/${messages.LIMIT}`,
  batches: `analytics/${messages.BATCHES}`,
  charts: `analytics/${messages.CHARTS}`,
  auditTrail: `analytics/${messages.AUDIT_TRAIL}`,
  reports: `analytics/reports`,
  viewReport: `analytics/reports/${messages.VIEW_REPORT}`,
  // genealogy: `analytics/genealogy`,
  // genealogyReport: `analytics/genealogy/report-view`,
  dashboard: `analytics/dashboard`,
  genealogy: `genealogy`,
  genealogyReport: `genealogy/report-view`,
};

export const userManagementRoutes = {
  users: "user-management",
  editUser: "user-management/users/:userId/edit",
  accessGroups: "user-management/access-groups",
  auditTrail: "user-management/audit-trail",
  createAccessGroup: "user-management/access-groups/create",
  editAccessGroup: "user-management/access-groups/:groupId/edit",
};
